if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const visibleSliders = new WeakSet();

	const syncActiveSlideVideo = (swiperInstance) => {
		const isVisible = visibleSliders.has(swiperInstance.el);

		swiperInstance.slides.forEach((slide, index) => {
			const video = slide.querySelector(".js-card-video");
			if (!video) return;

			if (isVisible && index === swiperInstance.activeIndex) {
				video.muted = true;
				const playPromise = video.play?.();
				if (playPromise?.catch) playPromise.catch(() => {});
			} else if (!video.paused) {
				video.pause();
			}
		});
	};

	const cardVideoObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const swiperInstance = entry.target.swiper;
				if (!swiperInstance) return;

				if (entry.isIntersecting) {
					visibleSliders.add(entry.target);
				} else {
					visibleSliders.delete(entry.target);
				}
				syncActiveSlideVideo(swiperInstance);
			});
		},
		{ rootMargin: "200px 0px" }
	);

	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			const disableDrag = !!slider.closest('[data-disable-card-drag]');

			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: !disableDrag,
				990: {
					allowTouchMove: false,
				},
				on: {
					init: syncActiveSlideVideo,
					slideChange: syncActiveSlideVideo,
				},
			});

			cardVideoObserver.observe(slider);
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
